// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Uo-z","slideIn":"Vo-z"};